import { Loader2 } from "lucide-react";

/**
 * Eager Suspense fallback for lazily-loaded routes. Kept in its own tiny module
 * (not inside a lazy chunk) so showing the loader never itself requires a
 * network round-trip. Intentionally minimal — the glass shell stays mounted
 * around it, so this only fills the page content slot while a chunk downloads.
 */
export function RouteFallback() {
  return (
    <div className="flex min-h-0 w-full flex-1 items-center justify-center py-16">
      <Loader2 className="size-5 animate-spin text-muted-foreground" />
    </div>
  );
}
